/* Product card image slider
   - native swipe on touch, trackpad scroll on desktop, click-and-drag with the mouse
   - moves the scroll indicator (.product-card__thumb) with the scroll position
   - works for cards added later (e.g. product recommendations), all events are delegated */
(function () {
  if (window.__productCardSlider) return;
  window.__productCardSlider = true;

  var SLIDER = '.product-card__slider';
  var MULTI = '.product-card__slider.is-multi';

  function closest(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }

  function updateThumb(slider) {
    var card = closest(slider, '.product-card');
    var thumb = card && card.querySelector('.product-card__thumb');
    if (!thumb) return;
    var n = slider.children.length;
    var max = slider.scrollWidth - slider.clientWidth;
    var p = max > 0 ? slider.scrollLeft / max : 0;
    thumb.style.transform = 'translateX(' + (p * (n - 1) * 100) + '%)';
  }

  // scroll does not bubble, so listen in the capture phase
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches(SLIDER)) updateThumb(t);
  }, true);

  // Sideways trackpad gestures over a slider belong to the slider:
  // stop them before the page's smooth-scroll (Lenis) swallows them.
  document.addEventListener('wheel', function (e) {
    if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
    if (closest(e.target, MULTI)) e.stopPropagation();
  }, { capture: true, passive: true });

  // Mouse drag
  var drag = null;
  var suppressClick = false;

  document.addEventListener('mousedown', function (e) {
    if (e.button !== 0) return;
    var slider = closest(e.target, MULTI);
    if (!slider) return;
    drag = { el: slider, x: e.clientX, left: slider.scrollLeft, moved: false };
    e.preventDefault(); // no text selection / image ghost
  });

  window.addEventListener('mousemove', function (e) {
    if (!drag) return;
    var dx = e.clientX - drag.x;
    if (!drag.moved && Math.abs(dx) > 5) {
      drag.moved = true;
      drag.el.classList.add('is-dragging');
    }
    if (drag.moved) drag.el.scrollLeft = drag.left - dx;
  });

  window.addEventListener('mouseup', function (e) {
    if (!drag) return;
    var d = drag;
    drag = null;
    if (!d.moved) return;

    suppressClick = true;
    setTimeout(function () { suppressClick = false; }, 60);

    var el = d.el;
    var w = el.clientWidth || 1;
    var n = el.children.length;
    var start = Math.round(d.left / w);
    var dx = e.clientX - d.x;
    var idx = start;
    if (dx < -w * 0.15) idx = start + 1;
    else if (dx > w * 0.15) idx = start - 1;
    idx = Math.max(0, Math.min(n - 1, idx));

    el.classList.remove('is-dragging');
    el.scrollTo({ left: idx * w, behavior: 'smooth' });
  });

  // a drag must not open the product
  document.addEventListener('click', function (e) {
    if (suppressClick && closest(e.target, '.product-card')) {
      e.preventDefault();
      e.stopPropagation();
      suppressClick = false;
    }
  }, true);
})();
